var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9L9.06569 3.56569C8.86768 3.36768 8.76867 3.26867 8.65451 3.23158C8.55409 3.19895 8.44591 3.19895 8.34549 3.23158C8.23133 3.26867 8.13232 3.36768 7.93431 3.56569L6.06569 5.43431C5.86768 5.63232 5.76867 5.73133 5.65451 5.76842C5.55409 5.80105 5.44591 5.80105 5.34549 5.76842C5.23133 5.73133 5.13232 5.63232 4.93431 5.43431L0.5 1M14.5 9H10.5M14.5 9V5",
    stroke: "#C57979",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trend-down.3c5bfa6d3993c262e8649dfc3c2f8b90.svg";
export { ForwardRef as ReactComponent };